import Rellax from "rellax";
import { breakpoints } from "../helpers/breakpoints";

/* Parallax scrolling is used on double image header */
export const parallax = () => {
  const parallaxItems = document.querySelectorAll("[js-rellax]");

  /* Check parallax item exists on page */
  if (!parallaxItems.length) {
    return;
  }

  new Rellax("[js-rellax]", {
    breakpoints: [
      breakpoints.screen0,
      breakpoints.screen1024,
      breakpoints.screen1920,
    ],
  });
};
